import {combineReducers, configureStore} from '@reduxjs/toolkit'
import dialog from "./slices/dialog";
import map from "./slices/map";
import debug from "@redux/slices/debug";

const reducer = combineReducers({
    debug,
    dialog,
    map
});

export const store = configureStore({reducer});